import { Button, Typography } from "@mui/material";
import moment from "moment";

import { TPaymentRequest } from "../../../../../@types";
import { apis, callApi } from "../../../../../api";
import { USDFormatter } from "../../../../../utils";

export type TPaymentRequestItemProps = {
	paymentRequest: TPaymentRequest;
};

export type TCancelPaymentRequestFieldValues = {
	reason: string;
};

export function PaymentRequestItem(props: TPaymentRequestItemProps) {
	const onClickPayNow = async () => {
		try {
			const response = await callApi({
				method: "PATCH",
				url: `${apis.BILL}/${props.paymentRequest.id}`,
			});

			if (response?.paymentResult?.url) {
				window.location.href = response.paymentResult.url;
			}
		} catch (error) {}
	};

	return (
		<div
			className="payment-request-item-container"
			key={props.paymentRequest.id}>
			<Typography className="normal-text">
				{"Course: "}
				<Typography component="span" className="normal-text bold">
					{props.paymentRequest.summary.course.name}
				</Typography>
			</Typography>
			<Typography className="normal-text">
				{"Instructor: "}
				<Typography component="span" className="normal-text bold">
					{`${props.paymentRequest.teacher.firstName} ${props.paymentRequest.teacher.lastName}`}
				</Typography>
			</Typography>
			<Typography className="normal-text">
				{"Total cost: "}
				<Typography component="span" className="normal-text bold">
					{USDFormatter.format(props.paymentRequest.totalCost / 100)}
				</Typography>
			</Typography>
			<Typography className="normal-text">
				{"Message: "}
				<Typography component="span" className="normal-text bold">
					{props.paymentRequest.message}
				</Typography>
			</Typography>
			<Typography className="normal-text">
				{"Requested at: "}
				<Typography component="span" className="normal-text bold">
					{moment(props.paymentRequest.createdAt).format("MMM DD YYYY, HH:mm")}
				</Typography>
			</Typography>
			{props.paymentRequest.status === "Issued" && (
				<Button
					className="normal-button primary-button pay-button no-transform item-separator-tiny"
					onClick={onClickPayNow}>
					Send payment
				</Button>
			)}
		</div>
	);
}
